import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_accents_ornaments: FaireCategoryEntity = {
  token: "cat_accents-ornaments",
  type: "category",
  name: "Ornaments & seasonal",
  level: 3,
  parentToken: "cat_home-decor-accents",
  href: "/category/home-decor/home-accents/ornaments-seasonal",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
